// 1. Check error
// 2. If 403 -> call the refresh token request
// 3. Fill the refresh request with a value, and check if the refresh request is null
// a. if not null, then wait
// b. if null, create a request for it to call the refresh endpoint
// 4. If the refresh endpoint returns a value, then run all the other endpoints through it
// 5. if the refresh endpoint throws an error, kick the user back to login page

import Cookies from 'js-cookie';
import { http } from './http';

let refreshRequestFunction = null;
const COOKIE_EXPIRE_DAYS = Number(process.env.REACT_APP_COOKIE_EXPIRE_DAYS);

export async function handleInitialAuthorizationError(error) {
  if (error.config?.url.includes('Auth/refresh')) {
    handleCleanup();
  }
  if (error.response.status === 401) {
    if (!refreshRequestFunction) refreshRequestFunction = handleRefreshTokenRequest();

    await refreshRequestFunction;
    return handleRetryLogic(error);
  }

  return Promise.reject(error);
}

export async function handleRefreshTokenRequest() {
  try {
    const response = await callRefreshTokenEndpoint();
    addNewTokenToDefaultHeaderRequest(response?.data?.token);
  } catch (error) {
    handleCleanup();
  }
}

function retrieveJwtTokenFromCookies() {
  return Cookies.get('jwtToken');
}

async function callRefreshTokenEndpoint() {
  const oldJwtToken = retrieveJwtTokenFromCookies();
  const response = await refreshTokenEndpoint(oldJwtToken);
  return response;
}

async function refreshTokenEndpoint(oldJwtToken) {
  try {
    return await http.post(
      '/Auth/refresh',
      {
        jwToken: oldJwtToken,
      },
      {
        headers: {
          Authorization: `Bearer ${oldJwtToken}`,
        },
        validateStatus: (status) => status < 400,
      }
    );
  } catch (error) {
    throw error;
  }
}

function addNewTokenToDefaultHeaderRequest(newToken) {
  Cookies.set('jwtToken', newToken, {
    expires: COOKIE_EXPIRE_DAYS,
    secure: true,
    sameSite: 'strict',
  });

  http.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
}

async function handleRetryLogic(error) {
  const originalConfig = error.config;
  try {
    return await http.request(originalConfig);
  } catch (error) {
    handleCleanup();
    throw error;
  } finally {
    refreshRequestFunction = undefined;
  }
}

function handleCleanup() {
  Cookies.remove('jwtToken');
  window.location.href = '/login';
  refreshRequestFunction = undefined; // ensure that this is always empty after the process
}
